const RELEASE = import.meta.env.VITE_RELEASE || '';
const ENVIRONMENT = import.meta.env.VITE_ENV || '';
const APP_VERSION = import.meta.env.VITE_APP_VERSION || '';
const API_URL = import.meta.env.VITE_API_URL || '';
const INVESTOR_PROMO_DOMAIN = import.meta.env.VITE_INVESTOR_PROMO_DOMAIN || '';
const FOUNDER_PROMO_DOMAIN = import.meta.env.VITE_FOUNDER_PROMO_DOMAIN || '';
const MAIN_PROMO_DOMAIN = import.meta.env.VITE_MAIN_PROMO_DOMAIN || '';
const FACEBOOK_LINK = import.meta.env.VITE_FACEBOOK_LINK || '#';
const LINKEDIN_LINK = import.meta.env.VITE_LINKEDIN_LINK || '#';
const INSTAGRAM_LINK = import.meta.env.VITE_INSTAGRAM_LINK || '#';
const GOOGLE_RECAPTCHA_SITE_KEY_V2 = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY_V2 || '';
const VERIFF_API_KEY = import.meta.env.VITE_VERIFF_PUBLISHABLE_KEY || '';
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';
const VERIFF_HOST_URL = 'https://stationapi.veriff.com';
const PREFIX = '/api';

const getApiURL = () => ENVIRONMENT === 'development' ? '' : API_URL;

const config = {
  mainPromoDomain: MAIN_PROMO_DOMAIN,
  investorPromoDomain: INVESTOR_PROMO_DOMAIN,
  founderPromoDomain: FOUNDER_PROMO_DOMAIN,
  facebookLink: FACEBOOK_LINK,
  linkedinLink: LINKEDIN_LINK,
  instagramLink: INSTAGRAM_LINK,
  baseURL: window.location.origin.toString(),
  apiURL: getApiURL() + PREFIX,
  veriffApiKey: VERIFF_API_KEY,
  veriffHostURL: VERIFF_HOST_URL,
  sentryDSN: SENTRY_DSN,
  environment: ENVIRONMENT,
  googleReCaptchaSiteKeyV2: GOOGLE_RECAPTCHA_SITE_KEY_V2,
  release: RELEASE,
  appVersion: APP_VERSION,
};

export default config;
